import { mutationCreateNote } from "./mutations/mutationCreateNote"
import { mutationDeleteNote } from "./mutations/mutationDeleteNote"
import { mutationUpdateNote } from "./mutations/mutationUpdateNote"
import { typeNote } from "./note"
import { queryNote } from "./queries/queryNote"
import { queryNotes } from "./queries/queryNotes"

const noteSchema = {
  types: [typeNote],
  resolvers: {
    Query: {
      ...queryNote,
      ...queryNotes,
    },
    Mutation: { ...mutationCreateNote, ...mutationDeleteNote, ...mutationUpdateNote },
  },
}

export default noteSchema
